import { useEffect, useState } from 'react';

// this hook is only safe for strictly client-side logic, such as button handling.
// do not use this hook for conditional JSX rendering unless absolutely necessary! it can tank page performance

export default function useWindowSize() {
    const isSSR = typeof window === 'undefined';
    const [windowSize, setWindowSize] = useState({
        width: isSSR ? 1200 : window.innerWidth,
        height: isSSR ? 800 : window.innerHeight,
    });

    function changeWindowSize() {
        setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    }

    useEffect(() => {
        window.addEventListener('resize', changeWindowSize);
        return () => {
            window.removeEventListener('resize', changeWindowSize);
        };
    }, []);

    const { width } = windowSize;
    return {
        width,
        isDesktop: width >= 1024,
        isMobile: width < 768,
        isTablet: width >= 768 && width < 1024,
    };
}
